import { forwardRef, HTMLAttributes, memo, ReactNode } from "react";
import classnames from "classnames";
import { CloseButton, CloseButtonProps } from "../../../CloseButton";

import styles from "./styles.module.scss";

export type SideoutMenuHeaderProps = HTMLAttributes<HTMLDivElement> & {
  text?: ReactNode
  icon?: ReactNode
  divider?: boolean
  children?: ReactNode
  textClassName?: string
  supportingText?: string
  onRequestClose?: CloseButtonProps["onClick"]
  childrenClassName?: string
};

export const SideoutMenuHeader = memo(
  forwardRef<HTMLDivElement, SideoutMenuHeaderProps>(
    (
      {
        text,
        icon,
        divider,
        children,
        className,
        textClassName,
        supportingText,
        onRequestClose,
        childrenClassName,
        ...props
      },
      ref,
    ) => {
      return (
        <div
          className={classnames(styles.root, className, {
            [styles.divider]: divider,
          })}
          {...props}
          ref={ref}
        >
          <div className={classnames(styles.headerWrapper, { [styles.withIcon]: !!icon })}>
            {icon}
            {text || supportingText ? (
              <div className={styles.headerTitleContent}>
                {text && (
                  <div className={classnames(styles.text, textClassName)}>
                    {text}
                  </div>
                )}
                {supportingText && (
                  <p className={styles.supportingText}>{supportingText}</p>
                )}
              </div>
            ) : null}
            <CloseButton
              className={styles.closeButton}
              onClick={onRequestClose}
            />
          </div>
          {children && (
            <div className={classnames(styles.children, childrenClassName)}>
              {children}
            </div>
          )}
        </div>

      );
    },
  ),
);
